/*
 * @Author: your name
 * @Date: 2021-11-24 16:20:20
 * @LastEditTime: 2021-11-24 16:59:16
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/utils/storage.js
 */
export function saveSessionStorage (key, val) {
  window.sessionStorage.setItem(key, val)
}
export function getSessionStorage (key) {
  return window.sessionStorage.getItem(key)
}
export function clearSessionStorage (key) {
  window.sessionStorage.removeItem(key)
}

export function saveLocalDicOption (data) {
  let opt = JSON.stringify(data)
  saveSessionStorage('dic_option', opt)
}

export function getLocalDicOption () {
  try {
    let opt = getSessionStorage('dic_option')
    if (opt) {
      return JSON.parse(opt)
    } else {
      return {
        departments: [],
        channels: []
      }
    }
  } catch (e) {
    return {
      departments: [],
      channels: []
    }
  }
}

export function saveLocalArea (data) {
  let opt = JSON.stringify(data)
  saveSessionStorage('dic_area', opt)
}

export function getLocalArea () {
  let opt = getSessionStorage('dic_area')
  try {
    if (opt) {
      return JSON.parse(opt)
    } else {
      return {
        departments: [],
        channels: []
      }
    }
  } catch (e) {
    return {
      departments: [],
      channels: []
    }
  }
}